import React, { useEffect,useState } from "react";

import "../scss/partner.scss"

import Aweb from "../img/parner/aweb.svg"
import Charity from "../img/parner/charity.svg"
import Droneua from "../img/parner/drone.ua.svg"
import Magnetto from "../img/parner/magnetto.svg"
import Reply from "../img/parner/reply.svg"
import Robota from "../img/parner/robota.svg"
import Sportbank from "../img/parner/sportbank.svg"
import UEF from "../img/parner/UEF.svg"
import Step from "../img/parner/logo_step.png"
import Min from "../img/parner/logo-min-ter.png"
import Dar from "../img/parner/darnecha.svg"
import DataMi from "../img/parner/logo-datami.png"

const ArrLogo = [Min,UEF,Robota,Reply,Magnetto,Droneua,Dar,DataMi,Sportbank,Charity,Aweb,Step]

const lengArr = {
    "en":{
        "partner":"Our partners"
    },
    "ua":{
        "partner":"Наші партнери"
    }
}

export function Partner(){
    const [leng, setLeng] = useState("en")

    useEffect(()=>{        
        const LengButtun = Array.prototype.slice.call(document.querySelectorAll(".button-leng"))
        LengButtun.forEach((el)=>{
            el.addEventListener("click",(el)=>{
                setLeng(el.target.id)
            })
        })
    },)
  
    return(
        <div className="partner">
            <div className="partner_title title">{`${lengArr[leng]['partner']}`}</div>
            <div className="partner-carusel">
            <div className="partner-carusel-screen">
                <div className="partner-carusel-screen_block">
                        {
                            ArrLogo.map((el)=>{
                                return( <img src={el} alt="logo" key={el} />)
                            })
                        }
                    </div>
                    <div className="partner-carusel-screen_block">
                        {
                            ArrLogo.map((el)=>{
                                return( <img src={el} alt="logo" key={el} />)
                            })
                        }
                    </div>
                    <div className="partner-carusel-screen_block">
                        {
                            ArrLogo.map((el)=>{
                                return( <img src={el} alt="logo" key={el} />)
                            })
                        }
                    </div>
                    <div className="partner-carusel-screen_block">
                        {
                            ArrLogo.map((el)=>{
                                return( <img src={el} alt="logo" key={el} />)
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
} 